import { render } from "./UiCurrencySelect.vue?vue&type=template&id=71048546&scoped=true&ts=true"
import script from "./UiCurrencySelect.vue?vue&type=script&lang=ts"
export * from "./UiCurrencySelect.vue?vue&type=script&lang=ts"

import "./UiCurrencySelect.vue?vue&type=style&index=0&id=71048546&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71048546"]])

export default __exports__